import { render, staticRenderFns } from "./ScreeningFormChooseContact.vue?vue&type=template&id=4631e55a&scoped=true&"
import script from "./ScreeningFormChooseContact.vue?vue&type=script&lang=js&"
export * from "./ScreeningFormChooseContact.vue?vue&type=script&lang=js&"
import style0 from "./ScreeningFormChooseContact.vue?vue&type=style&index=0&id=4631e55a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4631e55a",
  null
  
)

export default component.exports